import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_e185b7e9 from '../styles/Skeleton.module.less.js';

/**
 * @description Skeleton Avatar component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Avatar />
 * ```
 */
const Avatar = (props) => {
    const { className, inverted = false, ...restProps } = props;
    const cx = useStyles(modules_e185b7e9);
    const classNames = cx(className, 'avatar', { inverted });
    return React.createElement("div", { className: classNames, ...restProps });
};
Avatar.displayName = 'Avatar';

export { Avatar };
//# sourceMappingURL=Avatar.js.map
